import {Container, Button, Card, Row, Col, Form} from 'react-bootstrap';

import { useState, useEffect, useRef, useMemo, forwardRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import {  RecoilRoot,
    atom,
    selector,
    useRecoilState,
    useRecoilValue} from 'recoil';
import {
    Accordion,
    Tag,
    ColorPicker,
    SelectButton,
    InputNumber,
    FileUpload,
    Dialog,
    InputTextarea,
} from 'primereact';
import useMessage from '../../Hooks/useMessage';
import usePaginationValuesWhere from '../../Hooks/usePaginationValuesWhere';
import { buscar } from '../../Utils/Buscar';
import { useAuthentication, useTheme } from '../../Hooks';
import { DropZone } from '../DropZone/Dropzone';
import InputContainer from '../PantallasEdit/InputContainer/InputContainer';
import {CompaniaAtom, DateHelper, DEFAULT_PAGINATION_VALUES, FUENTE_CUENTA, PROCESAR_PAGO_TC} from '../../Utils';
import ReportesViewer from '../Reportes/ReportesViewer';
import { GridView } from '../GridView/GridView';
import ToolTip from '../ToolTip/Tooltip';
import IconButton from '../IconButton/IconButton';
import { SvgComponent } from '../SvgComponent/SvgComponent';
import uuid from 'react-uuid';
import Select from 'react-select'
import { useNavigate } from 'react-router';
import useExceptionHandler from "../../Hooks/useExceptionHandler";
import {
    ENVIAR_COMPROBANTE_MI_CUENTA,
    ENVIAR_EMAIL_AUTORIZACION_TARJETA
} from "../../../../Seguridad/Scripts/Utils/urls";
import {BUSCAR_FACTURAS_MI_CUENTA, OBTENER_REPORTE_FACTURA_CLIENTE} from "../../../../Facturacion/Scripts/Utils/urls";
import {DateTimePicker} from "../DateTimePicker/DateTimePicker";


const ESTATUS_CANCELADA = "C";
const ESTATUS_FACTURADA = "F";
const ESTATUS_PAGADA = "P";
const ESTATUS_CANCELADA_LABEL = "Cancelada";
const ESTATUS_FACTURADA_LABEL = "Facturada";
const ESTATUS_PAGADA_LABEL = "Pagada";

export function FacturasSection({showLoading,hideLoading}) {
    const navigate = useNavigate();
    const dialogPagoRef = useRef(null)
    const [pagoModalVisible, setPagoModalVisible] = useState(false);
    const [body, setBody] = useState(null);
    const [header, setHeader] = useState(null)
    const base64ref = useRef(null);
    const fileTypeRef = useRef(null);
    const contentTypeRef = useRef(null);
    const [companiaState, setCompaniaState] = useRecoilState(CompaniaAtom)
    const [showCanvasReporte, setShowCanvasReporte] = useState(false);
    const [reporte, setReporte] = useState(undefined);
    const [dateTimeKey, setDateTimeKey] = useState("fechasKey");
    const {Message,Error,Warning} = useMessage();
    const {handleException} = useExceptionHandler();
    const ESTATUS_LIST = [
        { value: "", label: "Todos" },
        {
            value: ESTATUS_CANCELADA,
            label: ESTATUS_CANCELADA_LABEL,
        },
        {
            value: ESTATUS_FACTURADA,
            label: ESTATUS_FACTURADA_LABEL,
        },
        {
            value: ESTATUS_PAGADA,
            label: ESTATUS_PAGADA_LABEL,
        },
    ];
    const [facturasList, setFacturasList] = useState([]);
    const [pagination, setPagination] = useState({
        ...DEFAULT_PAGINATION_VALUES,
    });
    const [dropZoneKey, setDropZoneKey] = useState("dropZone - first");
    const { setPaginationValuesWhere } = usePaginationValuesWhere();
    const [whereModal, setWhereModal] = useState(
        {
        }
    );
    const {theme} = useTheme();
    const consultaActualId = useRef();
    const [montoPendiente, setMontoPendiete] = useState('');
    const [montoColor, setMontoColor] = useState('');
    const [montoTotal, setMontoTotal] = useState('');
    const {usuario} = useAuthentication();
    const [queryParameters] = useSearchParams()
    const onPageIndexChanging = (pageNumber) => {
        setPagination((prevstate) => {
            return { ...prevstate, IndiceDePagina: pageNumber - 1 };
        });
        setWhereModal({ ...whereModal });
    };
    
    const transferenciaDescRef = useRef(null);
    const [tipoComprobante, setTipoComprobante] = useState('Transferencia');
    const [bancoEmisor, setBancoEmisor] = useState('');
    const [nombre, setNombre] = useState('');
    const [fechaTransferencia, setFechaTransferencia] = useState('');
    const [referencia, setReferencia] = useState('');

    const [modalType, setModalType] = useState('');
    const [currentIdSec, setCurrentIdSec] = useState(null);
    const [currentTotal, setCurrentTotal] = useState(null);

    const pagoTransferenciaBody = (idSec) => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <h3>Cuenta Bancaria</h3>
                <p className='bootstrapiso' style={{ marginTop: '0' }}>
                    <span className='font-weight-bold'>Banco</span>: Banco Popular Dominicano
                    <br />
                    <span className='font-weight-bold'>Tipo</span>: Cuenta Corriente
                    <br />
                    <span className='font-weight-bold'>Número</span>: 769921859
                    <br />
                    <span className='font-weight-bold'>Propietario</span>: Citrus Technology Group SRL
                    <br />
                    <span className='font-weight-bold'>RNC</span>: 130815348
                    <br />
                </p>

                <div style={{ marginBottom: '20px' }}>
                    <h4 style={{ fontSize: '18px', fontWeight: '500', marginBottom: '15px', color: '#6c757d' }}>
                        Información de Comprobante
                    </h4>

                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ fontSize: '14px', fontWeight: '500', marginBottom: '5px', display: 'block' }}>
                            ¿De qué tipo? <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div style={{ display: 'flex', gap: '15px' }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '14px' }}>
                                <input
                                    type="radio"
                                    name="tipoComprobante"
                                    value="Transferencia"
                                    checked={tipoComprobante === 'Transferencia'}
                                    onChange={(e) => setTipoComprobante(e.target.value)}
                                />
                                Transferencia
                            </label>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '14px' }}>
                                <input
                                    type="radio"
                                    name="tipoComprobante"
                                    value="Deposito"
                                    checked={tipoComprobante === 'Deposito'}
                                    onChange={(e) => setTipoComprobante(e.target.value)}
                                />
                                Depósito
                            </label>
                        </div>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ fontSize: '14px', fontWeight: '500', marginBottom: '5px', display: 'block' }}>
                            Banco Emisor:
                        </label>
                        <input
                            type="text"
                            value={bancoEmisor}
                            onChange={(e) => setBancoEmisor(e.target.value)}
                            placeholder="Ingrese el banco emisor"
                            style={{
                                width: '100%',
                                padding: '8px 12px',
                                border: '1px solid #ced4da',
                                borderRadius: '4px',
                                fontSize: '14px'
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ fontSize: '14px', fontWeight: '500', marginBottom: '5px', display: 'block' }}>
                            Nombre: <span style={{ color: 'red' }}>*</span>
                        </label>
                        <input
                            type="text"
                            value={nombre}
                            onChange={(e) => setNombre(e.target.value)}
                            placeholder="Ingrese su nombre completo"
                            style={{
                                width: '100%',
                                padding: '8px 12px',
                                border: '1px solid #ced4da',
                                borderRadius: '4px',
                                fontSize: '14px'
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ fontSize: '14px', fontWeight: '500', marginBottom: '5px', display: 'block' }}>
                            Fecha de Transferencia o Depósito: <span style={{ color: 'red' }}>*</span>
                        </label>
                        <input
                            type="date"
                            value={fechaTransferencia}
                            onChange={(e) => setFechaTransferencia(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '8px 12px',
                                border: '1px solid #ced4da',
                                borderRadius: '4px',
                                fontSize: '14px'
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <label style={{ fontSize: '14px', fontWeight: '500', marginBottom: '5px', display: 'block' }}>
                            Referencia o descripción de transferencia o depósito: <span style={{ color: 'red' }}>*</span>
                        </label>
                        <input
                            type="text"
                            value={referencia}
                            onChange={(e) => setReferencia(e.target.value)}
                            placeholder="Ingrese la referencia o descripción"
                            style={{
                                width: '100%',
                                padding: '8px 12px',
                                border: '1px solid #ced4da',
                                borderRadius: '4px',
                                fontSize: '14px'
                            }}
                        />
                    </div>
                </div>

                <h3>Comprobante</h3>
                <InputContainer label="Seleccione un archivo"><span style={{ color: 'red' }}>*</span>
                    <DropZone
                        key={dropZoneKey}
                        styles={{ marginLeft: "0px" }}
                        label="Dé click o arrastre la Imagen para continuar"
                        multiple={false}
                        updateFilesCb={customBase64Uploader}
                        type="image-pdf"
                        files={[]}
                        useVideo={false}
                    />
                </InputContainer>
                <h3>Descripcion</h3>
                <InputTextarea ref={transferenciaDescRef} rows={5} cols={30} />
                <div style={{ fontSize: '12px', color: '#6c757d', marginBottom: '15px' }}>
                    <span style={{ color: 'red' }}>*</span> Campos obligatorios
                </div>
                <div className='bootstrapiso'>
                    <div className="d-flex justify-content-center mt-3">
                        <Button type="button" onClick={(e) => {
                            e.preventDefault();
                            handleUploadTranferencia(idSec);
                        }} className="btn btn-success btn-lg form-control">Enviar</Button>
                    </div>
                </div>
            </div>
        )
    }

    const inputRef = useRef(null);
    const fechaRef = useRef(null)
    const cvvRef = useRef(null)
    const nombreTarjetaRef = useRef(null)
    const handleCardNumberChange = () => {
        let cardNumber = inputRef.current.value.replace(/\D/g, '').substring(0, 19);
        let formattedNumber;

        // Check if the card is an Amex card
        const isAmex = /^3[47]/.test(cardNumber);

        if (isAmex) {
            formattedNumber = cardNumber.replace(/(\d{4})(\d{6})(\d{5})/, '$1 $2 $3');
        } else {
            formattedNumber = cardNumber.replace(/(\d{4})(?=\d)/g, '$1 ');
        }

        inputRef.current.value = formattedNumber;
    };
    const handleExpDateChange = () => {
        let expDate = fechaRef.current.value.replace(/\D/g, '').substring(0, 4);
        let formattedExpDate = expDate.replace(/(\d{2})(?=\d)/g, '$1/');
        fechaRef.current.value = formattedExpDate;
    };
    const handleCvvChange = () => {
        let cvv = cvvRef.current.value.replace(/\D/g, '').substring(0, 4);
        cvvRef.current.value = cvv;
    };
    function validarTarjeta(){
        let messages = []
        let expDate = fechaRef.current.value;
        let today = new Date();
        let enteredMonth = parseInt(expDate.substring(0, 2), 10);
        let enteredYear = parseInt(expDate.substring(3, 5), 10);
        let enteredDate = new Date('20' + enteredYear, enteredMonth - 1, 1);

        if(!(enteredMonth <= 12)){
            messages.push("Fecha de expiracion incorrecta: Mes incorrecto ")
        }
        if(!(enteredDate > today)){
            messages.push("Fecha de expiracion incorrecta: La tarjeta esta vencida")
        }
        if(!inputRef.current.value){
            messages.push("Numero de tarjeta es requerido")
        }
        if(!cvvRef.current.value){
            messages.push("CVV es requerido")
        }
        if(cvvRef.current.value.length < 3){
            messages.push("CVV es incorrecto")
        }
        if(!nombreTarjetaRef.current.value){
            messages.push("Nombre del titular es requerido")
        }
        if(messages.length > 0){
            Warning({messages: messages})
        }
        return messages.length === 0;
    }
    const pagoTarjeta = (e, total, idSec) => {
        setPagoModalVisible(false)
        showLoading();
        e.preventDefault();
        if(validarTarjeta()){
            const consultaId = Math.random();
            consultaActualId.current = consultaId;
            const url = PROCESAR_PAGO_TC;
            let montoTotal = total;
            const impuestos = 0;
            let esCiaBloqueada = queryParameters.get('EsCiaBloqueada')
            let request = {IdSec:idSec,numero: inputRef.current.value,cvv: cvvRef.current.value,fecha: fechaRef.current.value,montoTotal,impuestos};
            if(esCiaBloqueada === 'true'){
                request.Origen = 'R'
            }
            try {
                buscar(url, {request}).then((data) => {
                    if (consultaId === consultaActualId.current) {
                        hideLoading();
                        if (data) {
                            if(data.ErrorMessages.length > 0){
                                Error({messages: data.ErrorMessages})
                            }else if (data.WarningMessages.length > 0){
                                Warning({messages: data.WarningMessages})
                            }else {
                                Message({messages: data.Messages})
                            }
                        }
                    }
                }).catch((err) => {
                    console.log(err);
                    hideLoading()
                })
            }catch (e) {
                console.log(e)
                hideLoading()
            }
        }else{
            hideLoading()
        }
    }
    const pagoTarjetaBody = (total, idSec) => {
        return (
            <div className='bootstrapiso'>
                <Card.Header style={{backgroundColor: '#fff',borderBottom: 'unset'}}>
                    <img style={{maxHeight: '50px', position:'absolute', right: '0', marginRight: '45px', paddingBottom: '20px'}} src="/img/tarjetas-pq.png" />
                </Card.Header>
                <Card.Body style={{ height: 'auto' }}>
                    <Row style={{ marginBottom: '1rem' }}>
                        <Col sm={8} md={8} className="pt-4">
                            <Row style={{ marginBottom: '1rem' }}>
                                <Col className="form-input" style={{ paddingRight: '0px', maxWidth: '55%', flex: '0 0 55%' }}>
                                    <Form.Group className="form-outline" data-mdb-input-init>
                                        <Form.Label htmlFor="cc-number">Número de tarjeta</Form.Label>
                                        <Form.Control
                                            type="tel" maxLength="19"
                                            id="txtNumero"
                                            name="cc-number"
                                            autoComplete="cc-number"
                                            placeholder="•••• •••• •••• ••••"
                                            required
                                            className="form-control cc-number"
                                            ref={inputRef}
                                            onChange={handleCardNumberChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col style={{ paddingRight: '7px', paddingLeft: '7px', maxWidth: '25%', flex: '0 0 22%' }}>
                                    <Form.Group className="form-outline" data-mdb-input-init>
                                        <Form.Label htmlFor="cc-exp">Exp.</Form.Label>
                                        <Form.Control
                                            type="tel" maxLength="5"
                                            id="txtFecha"
                                            name="cc-exp"
                                            autoComplete="cc-exp"
                                            placeholder="•• / ••"
                                            required
                                            className="form-control cc-exp"
                                            ref={fechaRef}
                                            onChange={handleExpDateChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col style={{ paddingLeft: '0', maxWidth: '25%', flex: '0 0 22%' }}>
                                    <Form.Group className="form-outline" data-mdb-input-init>
                                        <Form.Label htmlFor="cc-cvc">Cvv</Form.Label>
                                        <Form.Control
                                            type="tel" maxLength="4"
                                            id="txtCVV"
                                            name="cc-cvc"
                                            autoComplete="off"
                                            placeholder="•••"
                                            required
                                            className="form-control cc-cvc"
                                            ref={cvvRef}
                                            onChange={handleCvvChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group className="form-outline" data-mdb-input-init>
                                <Form.Label htmlFor="numeric">Nombre del titular</Form.Label>
                                <Form.Control
                                    type="text"
                                    id="txtNombre"
                                    name="cc-name"
                                    autoComplete="off"
                                    required
                                    className="input-lg form-control"
                                    ref={nombreTarjetaRef}

                                />
                            </Form.Group>
                        </Col>
                        <Col sm={4} md={4} className="pt-4">
                            <Row style={{ marginBottom: '1rem' }}>
                                <Col>
                                    <Form.Group className="form-outline" data-mdb-input-init>
                                        <Form.Label className="text-right" htmlFor="txtFacturaMontoSinImpuesto">Monto</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="txtFacturaMontoSinImpuesto"
                                            readOnly
                                            className="input-sm form-control text-right"
                                            value={total}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="form-outline" data-mdb-input-init>
                                        <Form.Label className="text-right" htmlFor="txtFacturaImpuesto">Impuesto</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="txtFacturaImpuesto"
                                            readOnly
                                            className="input-sm form-control text-right"
                                            value={0}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group className="form-outline" data-mdb-input-init>
                                <Form.Label className="text-right" htmlFor="txtFacturaTotal">Total</Form.Label>
                                <Form.Control
                                    type="text"
                                    id="txtFacturaTotal"
                                    readOnly
                                    className="input-sm form-control text-right"
                                    value={total}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Form.Group>
                        <Button type="button" onClick={(e) => pagoTarjeta(e, total, idSec)} className="btn btn-success btn-lg form-control">Procesar</Button>
                    </Form.Group>
                    <input id="cc-type" name="cc-type" type="hidden" value="" />
                </Card.Body>
            </div>
        )
    }

    function uint8ArrayToBase64(uint8Array) {
        let binaryArray = [];
        for (let i = 0; i < uint8Array.length; i++) {
            binaryArray.push(String.fromCharCode(uint8Array[i]));
        }
        return btoa(binaryArray.join(''));
    }
    
    const customBase64Uploader = async (event, esRecurrente = false) =>  {
        const file = event[0];
        if(file){
            if(validarArchivos(file)){
                const reader = new FileReader();
                reader.onload = function (e) {
                    
                    fileTypeRef.current = file.name.substring(file.name.lastIndexOf('.') + 1)
                    let contentType;
                    if(file.name.endsWith('.pdf')){
                        contentTypeRef.current = 'pdf'
                    }else{
                        contentTypeRef.current = 'img'
                    }
                    if(!e.target.result){
                        Warning({message: 'Error al cargar el archivo. Borre el archivo e intentelo nuevamente'})
                        return;
                    }
                    let bytes = new Uint8Array(e.target.result);
                    let base64String = uint8ArrayToBase64(bytes);
                    base64ref.current = base64String;
                };
                reader.readAsArrayBuffer(file);
            }
        }
    };
    function validarArchivos(file){
        let messages = [];
        if(!file){
            messages.push("Debe subir un archivo tipo imagen o pdf.")
        }else if(!file.name.endsWith('.pdf')
            && !file.name.endsWith('.jpeg')
            && !file.name.endsWith('.jpg')
            && !file.name.endsWith('.png')){
            messages.push("Debe incluir una imagen o documento de la autorización de pago. Formatos aceptados: [.pdf, .jpg, .jpeg, .png].")
        }
        if (messages.length > 0) {
            Warning({ messages: messages });
        }
        return messages.length === 0;
    }
    const handleUploadTranferencia = (idSec) => {

        if (!nombre.trim()) {
            Warning({ message: 'El campo Nombre es obligatorio.' });
            return;
        }
        if (!fechaTransferencia) {
            Warning({ message: 'La Fecha de Transferencia o Depósito es obligatoria.' });
            return;
        }
        if (!referencia.trim()) {
            Warning({ message: 'La Referencia o descripción es obligatoria.' });
            return;
        }
        if (!base64ref.current) {
            Warning({ message: 'Debe adjuntar el comprobante de pago para continuar con la solicitud.' });
            return;
        }

        setPagoModalVisible(false);
        showLoading();
        const consultaId = Math.random();
        consultaActualId.current = consultaId;
        const url = ENVIAR_COMPROBANTE_MI_CUENTA;
        const idsec = idSec.toString();
        try {
            buscar(url, {
                NumeroFactura: idsec,
                Descripcion: transferenciaDescRef.current.value,
                tipoComprobante: tipoComprobante,
                bancoEmisor: bancoEmisor,
                nombre: nombre,
                fechaTransferencia: fechaTransferencia,
                referencia: referencia,
                base64: base64ref.current,
                contentType: contentTypeRef.current,
                fileType: fileTypeRef.current
            }).then((data) => {
                if (consultaId === consultaActualId.current) {
                    hideLoading();
                    if(data.ErrorMessages.length > 0){
                        Error({messages: data.ErrorMessages})
                    }else if (data.WarningMessages.length > 0){
                        Warning({messages: data.WarningMessages})
                    }else {
                        Message({ messages: data.Messages });
                        onHidePagoModal();
                        limpiarFormularioTransferencia();
                    }
                }
            });   
        }catch (e) {
            handleException(e);
            hideLoading();
        }
    };

    const limpiarFormularioTransferencia = () => {
        setTipoComprobante('Transferencia');
        setBancoEmisor('');
        setNombre('');
        setFechaTransferencia('');
        setReferencia('');
        base64ref.current = null;
        fileTypeRef.current = null;
        contentTypeRef.current = null;
        if (transferenciaDescRef.current) {
            transferenciaDescRef.current.value = '';
        }
        setDropZoneKey(`dropZone-${Math.random()}`);
    };

    const pagoRecurrenteBody = () => {
        return (
            <div className='bootstrapiso'>
                <h3>Formulario</h3>
                <InputContainer label="Seleccione un archivo">
                    <DropZone
                        key={dropZoneKey}
                        styles={{ marginLeft: "0px" }}
                        label="Dé click o arrastre el archivo pdf para continuar"
                        multiple={false}
                        updateFilesCb={customBase64Uploader}
                        type="pdf"
                        files={[]}
                        useVideo={false}
                    />
                </InputContainer>
                <a href='../../../../templates/Formulario - Autorización Cargo Tarjeta Credito.pdf' target='_blank'>
                    Haz click aqui para descargar formulario de Pago Recurrente
                </a>
                <div className="d-flex justify-content-center mt-3">
                    <Button type="button" onClick={() => {
                        setPagoModalVisible(false)
                        setTimeout(() => {
                            handleUploadRecurrente()
                        },1000);
                    }} className="btn btn-success btn-lg form-control">Enviar</Button>
                </div>
            </div>

        )
    }
    const handleUploadRecurrente = () => {
        showLoading();
        const consultaId = Math.random();
        consultaActualId.current = consultaId;
        const url = ENVIAR_EMAIL_AUTORIZACION_TARJETA;
        try {
            buscar(url, { cliente: {Nombre: usuario.Compania.cliente.Nombre, TipoDocumento:usuario.Compania.cliente.TipoDocumento,Documento: usuario.Compania.cliente.Documento  }, base64: base64ref.current}).then((data) => {
                if (consultaId === consultaActualId.current) {
                    hideLoading();
                    if(data.ErrorMessages.length > 0){
                        Error({messages: data.ErrorMessages})
                    }else if (data.WarningMessages.length > 0){
                        Warning({messages: data.WarningMessages})
                    }else {
                        Message({messages: data.Messages})
                    }
                }
            });
        }catch (e) {
            hideLoading();
        }
    };
    const handleClick = (tipo, estatus = null, total = null, idSec = null) => {
        let messages = []
        if (tipo !== 'Recurrente') {
            if (estatus === "Pagada") {
                Warning({ message: 'Solo puede pagar facturas pendientes de cobro.' })
                return;
            }
            if (total <= 0) {
                Warning({ message: 'Solo puede pagar facturas con un monto pendiente mayor a 0.' })
                return;
            }
        }

        setCurrentIdSec(idSec);
        setCurrentTotal(total);
        setModalType(tipo);

        switch (tipo) {
            case 'Transferencia':
                setHeader('Envio de Comprobante de Pago')
                break;
            case 'Tarjeta':
                setHeader('Pago Directo con Tarjeta de Credito')
                break;
            case 'Recurrente':
                setHeader("Descarga y llena el formulario");
                break;
            default:
                break;
        }
        setPagoModalVisible(true);
    };
    const onViewReport = (idSec) => {
        const consultaId = Math.random();
        consultaActualId.current = consultaId;
        const url = OBTENER_REPORTE_FACTURA_CLIENTE;
        buscar(url, {idSec}).then((data) => {
            if (consultaId === consultaActualId.current) {
                if(data?.WarningMessages?.length > 0){
                    Warning({messages: data.WarningMessages})
                }else{
                    setReporte(data);
                    setShowCanvasReporte(true);   
                }
            }
        });
    };
    function onHidePagoModal(){
        setPagoModalVisible(false);
        setModalType('');
        setCurrentIdSec(null);
        setCurrentTotal(null);
    }
    useEffect(() => {
        const whereWithPaginationValues = { ...whereModal, ...pagination };
        const obtenerDatos = () => {
            const consultaId = Math.random();
            consultaActualId.current = consultaId;
            const url = BUSCAR_FACTURAS_MI_CUENTA;
            buscar(url, { where: whereWithPaginationValues }).then((data) => {
                if (consultaId === consultaActualId.current) {
                    setPaginationValuesWhere(data, pagination, setPagination);
                    setFacturasList(data.Resultados);
                    setMontoPendiete(data.montoFormateado);
                    setMontoTotal(data.montoPendiente);
                    setCompaniaState(data.montoFormateado)
                    setMontoColor(data.montoFormateado > 0 ?? 'red');
                }
            });
        };
        obtenerDatos();
    }, [whereModal]);
    return (
        <div>
            <Dialog ref={dialogPagoRef} header={header} visible={pagoModalVisible} style={{ width: '50vw' }} breakpoints={{ '1280': '50vw', '960px': '75vw', '641px': '450px', '400px': '350px' }} onHide={onHidePagoModal}
                pt={{
                    root: { style: { backgroundColor: '#fff' } },
                    header: { style: { backgroundColor: theme.color1, color: '#fff', borderRadius: '6px', margin: '10px', padding: '10px' } },
                    closeButtonIcon: { style: { color: '#fff' } },
                    mask: { style: { zIndex: '900003' } }
                }}
            >
                {modalType === 'Transferencia' && pagoTransferenciaBody(currentIdSec)}
                {modalType === 'Tarjeta' && pagoTarjetaBody(currentTotal, currentIdSec)}
                {modalType === 'Recurrente' && pagoRecurrenteBody()}
            </Dialog>
                    {showCanvasReporte && (
                        <ReportesViewer
                            showCanvas={showCanvasReporte}
                            setShowCanvas={setShowCanvasReporte}
                            reporte={reporte}
                        />
                    )}
                    <Container>
                        <h2 style={{ color: '#6c757d' }}>
                            Balance Pendiente:&nbsp;
                            <span style={{ color: parseInt(montoTotal) > 0 ? 'red' : 'inherit' }}>{montoPendiente}</span>
                        </h2>
                        <div className='d-flex justify-content-between mb-3' style={{maxWidth: '50%', gap: '20px'}}>
                            <Button type="button" style={{height:'auto',backgroundColor: theme.color1, borderRadius: '6px', borderColor: theme.color1}} onClick={() => handleClick('Tarjeta', null,montoTotal,0)} className="bootstrapiso btn btn-lg form-control">Pagar Balance Total</Button>
                            <Button type="button" style={{height:'auto',backgroundColor: theme.color1, borderRadius: '6px', borderColor: theme.color1}} onClick={() => handleClick('Recurrente')} className="bootstrapiso btn btn-lg form-control">Registrar Cargo Recurrente</Button>
                        </div>
                        <GridView
                            pagination={pagination}
                            setPagination={setPagination}
                            allowPaging={pagination.EsPaginable}
                            pageSize={pagination.CantidadPorPagina}
                            pageIndex={pagination.IndiceDePagina}
                            lastPageNumber={pagination.PaginasTotal}
                            dataSource={facturasList}
                            onPageIndexChanging={onPageIndexChanging}
                            where={whereModal}
                            setWhere={setWhereModal}
                            whereKey={"FacturaCitrus-where"}
                            fuente={FUENTE_CUENTA}
                            onReset={() => {
                                setDateTimeKey(uuid());
                            }}
                        >
                            <GridView.Column
                                isSticky
                                bodyRenderer={(row) => {
                                    return (
                                        <>
                                            <div className="float-right">
                                                <IconButton
                                                    onClick={() => handleClick("Tarjeta", row._EstatusDesc, row.MontoPendiente, row.IdSec)}
                                                >
                                                    <ToolTip message="Pago Directo con TC">
                                                        <div>
                                                            <SvgComponent
                                                                iconName="credit-card"
                                                                height="28px"
                                                                width="28px"
                                                            />
                                                        </div>
                                                    </ToolTip>
                                                </IconButton>
                                                <IconButton
                                                    onClick={() => handleClick("Transferencia", row._EstatusDesc,  row.MontoPendiente, row.IdSec)}
                                                >
                                                    <ToolTip message="Enviar Comprobante de Pago">
                                                        <div>
                                                            <SvgComponent
                                                                iconName="email"
                                                                height="25px"
                                                                width="25px"
                                                            />
                                                        </div>
                                                    </ToolTip>
                                                </IconButton>
                                                <IconButton onClick={() => onViewReport(row.IdSec)}>
                                                    <ToolTip message="Reporte">
                                                        <div>
                                                            <SvgComponent
                                                                iconName="print"
                                                                height="25px"
                                                                width="25px"
                                                            />
                                                        </div>
                                                    </ToolTip>
                                                </IconButton>
                                            </div>
                                        </>
                                    );
                                }}
                            />
                            <GridView.Column
                                headerText="ID"
                                dataField="IdSec"
                                sortExpression="IdSec"
                            />
                            <GridView.Column
                                headerText="Referencia"
                                dataField="NumeroFactura"
                                sortExpression="NumeroFactura"
                            />
                            <GridView.Column
                                headerText="Fecha"
                                dataField="Fecha"
                                sortExpression="Fecha"
                                width="200px"
                                filterRenderer={(_, onInputMultipleChange) => {
                                    return (
                                        <DateTimePicker
                                            key={dateTimeKey}
                                            esRangoFechas
                                            esGrid
                                            labelFechaInicio="Inicio"
                                            labelFechaFin="Fin"
                                            usarLabel={false}
                                            fechaInicioOriginal={
                                                whereModal?.FechaInicio ? whereModal.FechaInicio : ""
                                            }
                                            fechaFinOriginal={whereModal?.FechaFin ? whereModal.FechaFin : ""}
                                            onChange={(e) => {
                                                onInputMultipleChange(
                                                    {
                                                        target: { name1: "FechaInicio", value1: e.fechaInicio },
                                                    },
                                                    {
                                                        target: { name2: "FechaFin", value2: e.fechaFin },
                                                    }
                                                );
                                            }}
                                        />
                                    );
                                }}
                                bodyRenderer={(row) => {
                                    const fecha = DateHelper.formatStringDate(row.Fecha, false);
                                    return (
                                        <div className="mx-2" style={{ textAlign: "left" }}>
                                            {fecha}
                                        </div>
                                    );
                                }}
                            />
                            <GridView.Column
                                headerText="Estatus"
                                dataField="_EstatusDesc"
                                sortExpression="Estatus"
                                width="150px"
                                filterRenderer={(onInputChange) => {
                                    return (
                                        <Select
                                            className="basic-single"
                                            classNamePrefix="select"
                                            options={ESTATUS_LIST}
                                            value={ESTATUS_LIST.filter(function (option) {
                                                return (
                                                    option.value ===
                                                    (whereModal.Estatus ? whereModal.Estatus : ESTATUS_LIST[0].value)
                                                );
                                            })}
                                            name="Estatus"
                                            onChange={(e) =>
                                                onInputChange({ target: { name: "Estatus", value: e.value } })
                                            }
                                        />
                                    );
                                }}
                            />
                            <GridView.Column
                                headerText="NCF"
                                dataField="NCF"
                                sortExpression="NCF"
                            />
                            <GridView.Column
                                headerText="Total"
                                dataField="Total"
                                sortExpression="Total"
                                searchField="Total"
                                number
                            />
                        </GridView>
                    </Container>
                </div>
    )
}